import { useCallback } from 'react'
import FoldableVideoTitle from './components/FoldableVideoTitle'
import { TopicTextWrapper, Topics, UploaderInfoElement, UploaderName } from './Styled'
import { useNavigateTo } from 'hooks/useNavigateTo'
import { useToastAlert } from 'hooks/useToastAlert'

interface Topic {
  text: string
  params: any
}

export interface UploaderInfoProps {
  uploaderId?: string
  uploader?: string
  videoName?: string
  topics?: Topic[]
  [key: string]: any
}

const UploaderInfo = ({ uploaderId = '', uploader = '', videoName = '', topics = [], ...props }: UploaderInfoProps) => {
  const { navigateToViewMore, navigateToViewUploader } = useNavigateTo()
  const { toast } = useToastAlert()
  const openUploaderPage = useCallback(
    (ev: React.MouseEvent) => {
      ev.preventDefault()
      ev.stopPropagation()
      if (uploaderId && uploaderId !== '0') {
        navigateToViewUploader({ uploaderId })
      } else {
        toast('该视频无UP主资料')
      }
    },
    [navigateToViewUploader, toast, uploaderId]
  )

  const onClick = (text: string, params: any) => {
    navigateToViewMore({
      showAd: false,
      headerTitle: text,
      type: 'short',
      params,
    })
  }

  return (
    <UploaderInfoElement {...props}>
      {topics.length > 0 && (
        <Topics>
          <TopicTextWrapper>
            {topics.map((t, index) => (
              <span
                key={index}
                onClick={() => {
                  onClick(t.text, t.params)
                }}
              >
                {t.text}
              </span>
            ))}
          </TopicTextWrapper>
        </Topics>
      )}
      <UploaderName onClick={openUploaderPage}>{uploader}</UploaderName>
      <FoldableVideoTitle text={videoName} />
    </UploaderInfoElement>
  )
}

export default UploaderInfo
